import * as mwx from '@/utils/common.js';

/** 是否已执行过微信 JSSDK 初始化（页面刷新后会重置） */
let wxJssdkInited = false;

/**
 * 初始化微信 JSSDK（扫码等能力）。同一次访问内只执行一次，页面刷新后会重新执行。
 * 由路由守卫在进入需要扫码的页面时调用。
 */
export function initWxJssdk() {
  if (wxJssdkInited) return;
  wxJssdkInited = true;

  mwx.api.elfinH5JsSdk().then((res) => {
    if (typeof wx === 'undefined') return;

    wx.config({
      debug: false,
      appId: res.appId,
      timestamp: res.timestamp,
      nonceStr: res.nonceStr,
      signature: res.signature,
      jsApiList: ['chooseImage','getLocalImgData','uploadImage']
    });
    wx.ready(function () {
      console.log('微信 JSSDK 初始化成功');
    });
    wx.error(function (err) {
      console.error('微信 JSSDK 初始化失败:', err.errMsg || err);
    });
  });
}
